import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InfoToken } from "../../infoToken";
import Layout from "../../layouts/Layout";
import {
  changeStatut,
  currentuserconnected,
  getAllUserAPI,
  changeStatutUserApi,
  profilUserConnected,
} from "../../services/utilisateurs/UtilisateursRequest";
import Paginate from "../pagination";
import AjoutUtilisateur from "./AjoutUtilisateurAPI";
import { Oval } from "react-loader-spinner";
import UpdateProfilUtilisateur from "./UpdateProfilUtilisateurAPI";
import UpdatePasswordUtilisateur from "./UpdatePasswordUtilisateurAPI";

function Utilisateurs(props) {
  const { t } = useTranslation();
  const [listeUtilisateurs, setlisteUtilisateurs] = useState([]);
  const [totalElement, settotalElement] = useState(0);
  const [totalElementByPage, setTotalElementByPage] = useState(0);
  const [filterParametres, setfilterParametres] = useState({ param: "" });
  const [pageActive, setPageActive] = useState(1);
  const [infoUser, setinfoUser] = useState({});
  const [loading, setloading] = useState(false);

  const handlePageChange = (pageNumber) => {
    setPageActive(pageNumber);
    afficherListeUtilisateur(pageNumber, filterParametres);
  };

  //Liste des utilisateurs
  const afficherListeUtilisateur = (currentPage, params) => {
    setloading(true);
    getAllUserAPI(currentPage, params)
      .then((res) => {
        setloading(false);
        setlisteUtilisateurs(res.data.donnee.data);
        settotalElement(res.data.donnee.total);
        setTotalElementByPage(res.data.donnee.per_page);
      })
      .catch((error) => setloading(false));
  };

  useEffect(() => {
    afficherListeUtilisateur(pageActive, filterParametres);
  }, []);

  //Changement d'état de l'utilisateur
  const handleStatut = (id) => {
    setloading(true);
    changeStatutUserApi(id)
      .then((res) => {
        setloading(false);
        afficherListeUtilisateur(pageActive, filterParametres);
      })
      .catch((error) => setloading(false));
  };

  //Zone de recherche
  const handleSearchUser = (values) => {
    filterParametres.param = values.target.value;
    afficherListeUtilisateur(1, { params: values.target.value });
  };

  const trUsers = listeUtilisateurs.map((item, index) => (
    <tr
      key={index}
      onClick={() => setinfoUser(item)}
      className={item.recevoirDemandeReversement ? "text-warning" : ""}
    >
      <td data-bs-toggle="modal">
        {item.nom}
      </td>
      <td data-bs-toggle="modal">
        {item.id}
      </td>
      <td data-bs-toggle="modal">
        {item.email}
      </td>
      <td data-bs-toggle="modal">
        {item.numero}
      </td>
      <td data-bs-toggle="modal">
        {item.fonction}
      </td>
      {
        localStorage.getItem("role") === "ROLE_ADMIN" && (
          <td data-bs-toggle="modal" data-bs-target="#ajoutUtilisateur">
            {item.prestataire != null && item.prestataire != null ? item.prestataire.nom : ""}
          </td>
        )
      }
      <td>
        <button className="btn btn-sm" onClick={() => handleStatut(item.id)}>
          {" "}
          {item.etat === 100 ? (
            <span className="btn text-success">
              <i className="fa fa-sign-in-alt"></i> {t('users.status.active')}
            </span>
          ) : (
            <span className="btn text-danger">
              {" "}
              <i className="fa fa-ban"></i> {t('users.status.inactive')}
            </span>
          )}{" "}
        </button>

        {localStorage.getItem("role") === "ROLE_ADMIN" && (
          <button
            onClick={() => setinfoUser(item)}
            data-bs-toggle="modal"
            data-bs-target="#updateProfilUtilisateur"
            className="btn btn-sm"
          >
            <i className="fa fa-pencil-alt"></i>
          </button>
        )}

        {localStorage.getItem("role") === "ROLE_ADMIN" && (
          <button
            onClick={() => setinfoUser(item)}
            data-bs-toggle="modal"
            data-bs-target="#updatePasswordUtilisateur"
            className="btn btn-sm"
          >
            <i className="fa fa-lock"></i>
          </button>
        )}

        {/* <button onClick={()=>setinfoUser(item)} data-bs-toggle="modal" data-bs-target="#updateProfilUtilisateur" className='btn btn-sm'><i className='fa fa-pencil-alt'></i></button> */}
      </td>
    </tr>
  ));

  return (
    <Layout>
      <div>
        <div className="Filtre"></div>
        <div className="search d-flex justify-content-center mt-1">
          <div className="ui icon input">
            <input
              type="text"
              onChange={(e) => handleSearchUser(e)}
              placeholder={t('users.search')}
            />
            <i className="circular search link icon"></i>
          </div>
        </div>
        <div className="container">
          <div className="d-flex justify-content-between mt-5">
            <div className="fw-bold">
              <legend>{t('usersApi.title')}</legend>
            </div>
            {localStorage.getItem("role") !== "ROLE_UTILISATEUR_SERVICE" && (
              <div className="">
                <a
                  type="button"
                  onClick={() => setinfoUser({})}
                  data-bs-toggle="modal"
                  data-bs-target="#ajoutUtilisateur"
                  className="btn colorYelloSkanPay text-black  btn-md"
                >
                  {" "}
                  <i className="fa fa-plus-circle"></i> {t('users.newUser')}
                </a>
                {/* <AjoutUtilisateur afficherListeUtilisateur={afficherListeUtilisateur} /> */}
              </div>
            )}
          </div>
          <div className="table-responsive mt-4">
            <table className="table table-bordered celled padded">
              <thead>
                <tr>
                  <th className="single line">{t('users.table.fullName')}</th>
                  <th>{t('users.table.login')}</th>
                  <th>{t('users.table.email')}</th>
                  <th>{t('users.table.phone')}</th>
                  <th>{t('users.table.function')}</th>
                  {localStorage.getItem("role") === "ROLE_ADMIN" && <th>{t('users.table.provider')}</th>}
                  <th width="15%">{t('users.table.status')}</th>
                </tr>
              </thead>
              <tbody>{!loading && trUsers}</tbody>

              <tfoot>
                <tr>
                  <th colSpan="7">
                    <div className="d-flex justify-content-center">
                      <Paginate
                        pageActive={pageActive}
                        handlePageChange={handlePageChange}
                        nbreElementParPage={totalElementByPage}
                        nbreTotalElmentPage={totalElement}
                      />
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
          {loading && (
            <div className="d-flex justify-content-center">
              <Oval width={30} height={30} color="#344b7b" visible={loading} />
            </div>
          )}
          <AjoutUtilisateur
            data={infoUser}
            setPageActive={setPageActive}
            afficherListeUtilisateur={afficherListeUtilisateur}
          />
          <UpdateProfilUtilisateur
            data={infoUser}
            setPageActive={setPageActive}
            afficherListeUtilisateur={afficherListeUtilisateur}
          />
          <UpdatePasswordUtilisateur
            data={infoUser}
            setPageActive={setPageActive}
            afficherListeUtilisateur={afficherListeUtilisateur}
          />
        </div>
      </div>
    </Layout>
  );
}

export default Utilisateurs;
